import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import {
  AddUserTag,
  getUsers,
  RemoveUserTag,
  setUserStoredPage,
  setUserStoredPagesize,
} from "../../../redux/features/Settings/Management/Users";

import { useLocation, useNavigate } from "react-router-dom";
import { getUserDetailsStateAction } from "../../../redux/features/users/userDetails";
import ICONS from "../../../assets/Icons";

import PaginationComponent from "../../../components/_utils/PaginationComponent";
import Loader from "../../../components/Loader/Index";
import PrimaryButton from "../../../components/_utils/CommonButtons/PrimaryButton";
import CardContainer from "../../../components/_utils/CommonViewAllCard/CardContainer";
import TextWithIcon from "../../../components/_utils/CommonViewAllCard/CardSubComponent/TextWithIcon";
import TopNavComponent from "../../../components/_utils/CommonTopNav/TopNavComponent";
import useServiceChecker from "../../../components/ServiceChecker";
import CommonAssignTagPopup from "../../../components/_utils/CommonPopups/CommonAssignTagPoppup";
import {
  GlobalConfiguration,
  IntervalConfiguration,
  PaginationConfiguration,
} from "../../../utils/configurationProvider";
import CommonToast from "../../../components/_utils/CommonToast";
import useCustomSearchParams from "../../../utils/useCustomSearchParams";
import useMultiSelect from "../../../utils/useMultiSelect.js";
import { toast } from "react-toastify";
import accountNameStandardised from "../../../utils/accountNamestandardised";
import useRestrictedAction from "../../../hooks/useRestrictedAction";
import UseHandleScroll from "../../../hooks/useHandleScroll";
const UsersSettings = ({
  type,
  setIsPopUpOpen,
  setPayload,
  selectedValueUser,
  flow = "",
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const dropdownOptions = PaginationConfiguration.paginationOptions;
  const { searchParam, handleSearchParams, handleClearSearchParam } =
    useCustomSearchParams({
      pageno: GlobalConfiguration.lengthCheckOne,
      pagesize: dropdownOptions[GlobalConfiguration.lengthCheckZero],
    });

  const [currentPage, setCurrentPage] = useState(
    searchParam.get("pageno") || GlobalConfiguration.lengthCheckOne,
  );

  const [pageSize, setPageSize] = useState(
    searchParam.get("pagesize") ||
      dropdownOptions[GlobalConfiguration?.lengthCheckOne],
  );

  const [selectedValue, setSelectedValue] = useState(
    searchParam.get("pagesize") ||
      dropdownOptions[GlobalConfiguration?.lengthCheckOne],
  );

  const [isTagsPopupOpen, setIsTagsPopupOpen] = useState(false);
  const [multiSelect, setMultiSelect] = useState(false);
  const [usersDetails, setUsersDetails] = useState([]);
  const [usersArray, setUsersArray] = useState([]);
  const [mainData, setMainData] = useState([]);
  const [allTags, setAllTags] = useState([]);
  const [tagState, setTagState] = useState([]);
  const [newSelectedTags, setNewSelectedTags] = useState([]);
  const [searchUserText, setSearchUserText] = useState(
    searchParam.get("search") || "",
  );
  const [loader, setLoader] = useState(true);
  const filterRef = useRef(null);
  const [allData, setAllData] = useState([]);
  const [ownerTagState, setOwnerTagState] = useState(
    searchParam.get("tags") || [],
  );
  const [, setIsOpen] = useState(false);
  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);
  const [active, setActive] = useState("");
  const [typedText, setTypedText] = useState("");
  const [inputData, setInputData] = useState({});

  const lastScrollTop = useRef(GlobalConfiguration.lengthCheckZero);
  const [direction, setDirection] = useState("");
  const [isScrolling, setIsScrolling] = useState(false);
  const scrollEndTimerRef = useRef(null);

  const { handleScroll } = UseHandleScroll(
    setDirection,
    lastScrollTop,
    GlobalConfiguration.remitterAcountGridCardHeight,
  );

  const handleGridScroll = (e) => {
    handleScroll(e);
    setIsScrolling(true);
    clearTimeout(scrollEndTimerRef.current);
    scrollEndTimerRef.current = setTimeout(
      () => setIsScrolling(false),
      IntervalConfiguration.intervalExtraSmall,
    );
  };

  useEffect(() => () => clearTimeout(scrollEndTimerRef.current), []);

  const [sortValue, setSortValue] = useState(searchParam.get("sort") || "");
  const [selectedGrade, setSelectedGrade] = useState(
    searchParam.get("grade") || "",
  );
  const [selectedStatus, setSelectedStatus] = useState(
    searchParam.get("status") || "",
  );

  const [ensureAll] = useServiceChecker();

  const hasCreateUserService = ensureAll(["CEmp"]);

  const [selectedAccount, setSelectedAccount] = useState(
    "All selected accounts",
  );
  const [selectedAssignedAccountID, setSelectedAssignedAccountID] =
    useState("");

  const {
    handleChange,
    handleSelectAll: handleMultiSelectAll,
    handleSingleSelect,
  } = useMultiSelect();

  // usersArray now stores full user objects (like FieldForce's labelTransactions),
  // so it plugs directly into useMultiSelect. selectedUserIds is the plain id list
  // needed everywhere else (API calls, filters, etc.).
  const selectedUserIds = usersArray?.map((u) => u?.id) || [];

  const selectedTagsCards = usersDetails?.filter((account) =>
    selectedUserIds.includes(account.id),
  );

  const tagActionDispatchedRef = useRef(false);

  let availableTags = mainData?.available_tags || tagState || [];

  const showLoader = loader && !isTagsPopupOpen;
  const hasUsers = usersDetails?.length > GlobalConfiguration.lengthCheckZero;

  useEffect(() => {
    sessionStorage.removeItem("userDetailsInfostorage");
  }, []);

  const { showRestrictedAction } = useRestrictedAction();

  const actionRestricted = () => {
    showRestrictedAction();
  };

  const handleUserDetails = (data) => {
    if (type === "popup") {
      setIsPopUpOpen(false);
      setPayload((prev) => {
        const fullName = `${data.first_name} ${data.last_name ?? ""}`.trim();
        return {
          ...prev,
          linked_user_id: data?.id,
          userName: accountNameStandardised(fullName),
          userId: data.user_id,
          ...(selectedValueUser === "username" && {
            account_name: fullName,
          }),
        };
      });
    } else {
      let userDetailsInfo = false;
      userDetailsInfo = usersDetails.filter((fil) => {
        return fil.id === data.id;
      });
      if (userDetailsInfo) {
        dispatch(setUserStoredPage(currentPage));
        dispatch(setUserStoredPagesize(selectedValue));
        navigate(`/settings/user_view_all/user_detail_page/${data.id}`, {
          state: {
            isViewAll: location.pathname.includes(`settings/user_view_all`)
              ? true
              : false,
          },
        });

        dispatch(getUserDetailsStateAction(userDetailsInfo));
        sessionStorage.setItem(
          "userDetailsInfostorage",
          JSON.stringify(userDetailsInfo),
        );
      }
    }
  };

  useEffect(() => {
    if (selectedAccount !== "All selected accounts") {
      const selectedAccountTags =
        allData?.find((account) => account.id === selectedAssignedAccountID)
          ?.account_tags || [];

      setNewSelectedTags(
        selectedAccountTags.map((tag) => ({
          value: tag,
          selected: true,
          type: "ownerTags",
        })),
      );

      setAllTags(
        availableTags?.map((tag) => ({
          value: tag,
          selected: true,
          type: "ownerTags",
        })),
      );
    } else if (
      selectedTagsCards?.length &&
      selectedAccount !== "All selected accounts"
    ) {
      const accountTags =
        allData?.find((account) => selectedUserIds.includes(account.id))
          ?.account_tags || [];
      setNewSelectedTags(
        accountTags.map((tag) => ({
          value: tag,
          selected: true,
          type: "ownerTags",
        })),
      );
      setAllTags(
        availableTags?.map((tag) => ({
          value: tag,
          selected: true,
          type: "ownerTags",
        })),
      );
    } else if (
      selectedTagsCards?.length ||
      selectedAccount === "All selected accounts"
    ) {
      let a = allData?.filter((account) =>
        selectedUserIds.includes(account.id),
      );
      const commonTags = a.reduce((common, account) => {
        return common.filter((tag) => account.account_tags?.includes(tag));
      }, a[GlobalConfiguration?.lengthCheckZero]?.account_tags || []);

      const uncommonTags = a.reduce((uncommon, account) => {
        return uncommon.concat(
          account.account_tags?.filter((tag) => !commonTags.includes(tag)) ||
            [],
        );
      }, []);

      setNewSelectedTags(
        commonTags.map((tag) => ({
          value: tag,
          selected: true,
          type: "ownerTags",
        })),
      );

      setAllTags(
        [...new Set([...availableTags, ...uncommonTags])].map((tag) => ({
          value: tag,
          selected: true,
          type: "ownerTags",
        })),
      );
    } else {
      setNewSelectedTags([]);
      setAllTags(
        availableTags?.map((tag) => ({
          value: tag,
          selected: true,
          type: "ownerTags",
        })),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    usersArray,
    mainData,
    selectedAssignedAccountID,
    selectedAccount,
    allData,
    selectedTagsCards?.length,
  ]);

  const handleAddTags = async (item) => {
    if (tagActionDispatchedRef) {
      tagActionDispatchedRef.current = true;
    }

    try {
      setLoader(true);

      let response = await dispatch(
        AddUserTag({
          user_id:
            selectedAssignedAccountID !== ""
              ? [selectedAssignedAccountID]
              : selectedUserIds,
          tags: item?.type === "newAss" ? item?.data1 : [item],
        }),
      );

      if (response?.payload?.status === true) {
        let val = allData.map((itm) => {
          if (selectedUserIds.includes(itm.id)) {
            return {
              ...itm,
              account_tags: [
                ...new Set([
                  ...(itm.account_tags || []),
                  ...(response?.meta?.arg?.tags || []),
                ]),
              ],
            };
          }
          return itm;
        });
        setAllData(val);
        await fetchData(true);
        toast.dismiss();
        CommonToast({
          text: <>Tags assigned successfully. </>,
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
        setLoader(false);
      } else {
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
    }
  };

  const handleRemoveTags = async (item) => {
    if (tagActionDispatchedRef) {
      tagActionDispatchedRef.current = true;
    }
    try {
      setLoader(true);

      const response = await dispatch(
        RemoveUserTag({
          user_id:
            selectedAssignedAccountID !== ""
              ? [selectedAssignedAccountID]
              : selectedUserIds,
          tags: item,
        }),
      );

      if (response?.payload?.status === true) {
        let val = allData.map((itm) => {
          if (selectedUserIds.includes(itm.id)) {
            return {
              ...itm,
              account_tags: itm.account_tags.filter(
                (tag) => !response?.meta?.arg?.tags?.includes(tag),
              ),
            };
          }
          return itm;
        });
        await fetchData(true);
        setAllData(val);
        toast.dismiss();
        CommonToast({
          text: "Tag unassigned successfully.",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
        setLoader(false);
      } else {
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
    }
  };

  const fetchData = async () => {
    let queryParams = {
      page_no: currentPage,
      page_size: pageSize,
      search_string: searchUserText,
      account_tags: ownerTagState,
      sort_by:
        sortValue === "Alphabetical : A to Z"
          ? "ascending"
          : sortValue === "Alphabetical : Z to A"
            ? "descending"
            : sortValue === "Order : Latest"
              ? "latest"
              : sortValue === "Order : Oldest"
                ? "oldest"
                : "ascending",
      grade: selectedGrade || undefined,
      active_status:
        selectedStatus === "Active"
          ? "Y"
          : selectedStatus === "Inactive"
            ? "N"
            : undefined,
    };

    setLoader(true);
    try {
      const response = await dispatch(getUsers(queryParams));
      const newData = response?.payload?.employees || [];
      if (!searchUserText && !ownerTagState) {
        setTagState(response?.payload?.available_tags);
      } else {
        if (sessionStorage?.getItem("UserAvailableTags")) {
          let val = sessionStorage?.getItem("UserAvailableTags");
          setTagState(JSON.parse(val) || []);
        }
      }
      setMainData(response?.payload || []);

      setLoader(false);

      setAllData((prev) => {
        return [
          ...new Map(
            [...prev, ...newData].map((item) => [item["id"], item]),
          ).values(),
        ];
      });
      setUsersDetails(newData);
    } catch (error) {
      setLoader(false);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Tab") {
      event.preventDefault();
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    searchUserText,
    pageSize,
    currentPage,
    ownerTagState,
    selectedGrade,
    selectedStatus,
    sortValue,
  ]);

  const handleSelect = (value) => {
    setDirection("");
    handleSubmit("pagesize", value);
    if (
      multiSelect &&
      value === PaginationConfiguration.paginationSmall &&
      usersArray?.length > PaginationConfiguration.paginationSmall
    ) {
      handleChange(usersArray, setUsersArray, value, usersDetails);
    }
    setSelectedValue(value);
    setPageSize(value);
    setCurrentPage(GlobalConfiguration.lengthCheckOne);
  };

  // "Select up to N" toggle for the tag-assign flow (N = current pagesize)
  const handleSelectAllUsers = () => {
    handleMultiSelectAll(
      usersArray,
      setUsersArray,
      selectedValue,
      usersDetails,
    );
  };

  const handlePagination = (page) => {
    setDirection("");
    handleSubmit("pageno", page);
    setCurrentPage(page);
  };

  useEffect(() => {
    if (filterRef.current) {
      filterRef.current.scrollTo({
        top: GlobalConfiguration?.lengthCheckZero,
      });
    }
  }, [currentPage, usersDetails]);

  useEffect(() => {
    let data;
    switch (active) {
      case "Tags":
        data = allTags
          ?.filter((itm) => itm.value.startsWith(typedText))
          ?.map(({ value }) => {
            return { id: value, Tag: value };
          });
        break;
      case "Search":
        setSearchUserText(typedText);
        break;
      default:
    }
    setInputData(data);
  }, [active, allTags, typedText]);

  const handleClose = () => {
    setIsTagsPopupOpen(false);

    if (tagActionDispatchedRef.current) {
      fetchData();
      setUsersArray([]);
      setMultiSelect(false);
    }
  };

  const handleSubmit = (key, value) => {
    if (type !== "popup") handleSearchParams(key, value);
  };

  const handleClearParams = () => {
    handleClearSearchParam();

    if (showInnerSearchBar) return;
    setSearchUserText("");
    setTypedText("");
    setOwnerTagState([]);
    setSelectedGrade("");
    setSelectedStatus("");
    setCurrentPage(1);
  };

  return (
    <div
      className={`bg-primary-bg relative flex flex-col overflow-hidden ${type === "popup" ? "h-full" : "h-screen w-full-width"}`}
    >
      {hasUsers && !showLoader && (
        <div
          className={`${type === "popup" ? "absolute" : "fixed"} ${showInnerSearchBar ? "z-z-index-header" : "z-z-index-dropdown"} bg-primary-nav shadow-box-shadow-top bottom-bottom-base w-full rounded-none`}
        >
          <div
            className={showInnerSearchBar ? "pointer-events-none h-full" : ""}
          >
            {showInnerSearchBar && (
              <div className="absolute bg-PopUp-BackDrop opacity-dark-opacity w-full h-full z-z-index-header pointer-events-none"></div>
            )}
            <PaginationComponent
              handleSelect={handleSelect}
              selectedValue={selectedValue}
              data={mainData}
              pageSize={pageSize}
              dropdownOptions={dropdownOptions}
              handlePagination={handlePagination}
              currentPage={currentPage}
              setIsOpen={setIsOpen}
            />
          </div>
        </div>
      )}

      {isTagsPopupOpen && (
        <div
          onClick={() => setIsTagsPopupOpen(false)}
          className="fixed left-left-base w-full top-top-base h-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-z-index-max"
        >
          <CommonAssignTagPopup
            headerTitle="Assign/Unassign tags:"
            closehandleFunction={handleClose}
            closedisabledBgColor=""
            closebuttonRef=""
            closeimgColor=""
            loading={loader}
            newTags={newSelectedTags}
            handleAddTags={handleAddTags}
            handleRemoveTags={handleRemoveTags}
            setNewTags={setNewSelectedTags}
            AllTags={allTags}
            setAllTags={setAllTags}
            setLoading={setLoader}
            selectedAssignedAccountID={selectedAssignedAccountID}
            selectedAccount={selectedAccount}
            setSelectedAccount={setSelectedAccount}
            setSelectedAssignedAccountID={setSelectedAssignedAccountID}
            ownerDetailData={[
              ...new Map(allData.map((item) => [item["id"], item])).values(),
            ].filter((account) => selectedUserIds.includes(account.id))}
            users={[
              ...new Map(allData.map((item) => [item["id"], item])).values(),
            ]
              .filter((account) => selectedUserIds.includes(account.id))
              ?.map((ac) => ac.first_name)}
            type="userViewAll"
          />
        </div>
      )}

      <div
        className={`relative z-z-index-overlay flex-shrink-0 ${direction === "down" ? "bg-primary-bg" : "bg-primary-nav"} ${type === "popup" ? "hidden" : "block"}`}
      >
        <div className="hidden Qsmd:block h-navbar-breadcrumb-height w-full"></div>
      </div>

      <div className="bg-primary-nav flex flex-col items-center justify-center z-z-index-dropdown w-full relative">
        <TopNavComponent
          direction={direction}
          handleBack={() => navigate("/settings")}
          topNavCtaBtn1Props={
            multiSelect
              ? {
                  btnText: usersArray?.length ? "Clear" : "Cancel",
                  btnType: "button",
                  enabledBgColor: "var(--primary-nav-act)",
                  handleFunction: () => {
                    setUsersArray([]);
                    if (!usersArray.length) {
                      setMultiSelect(false);
                    }
                  },
                  enabledTextColor: "var(--text-primary)",
                  isDisabled: false,
                  hoverOption: "white",
                }
              : null
          }
          topNavCtaBtnWithIcon1Props={
            multiSelect || type === "popup"
              ? undefined
              : {
                  btnText: "Create user",
                  btnType: "button",
                  handleFunction: () => {
                    if (hasCreateUserService.status) {
                      navigate("/settings/users/create_user");
                    } else {
                      navigate("/feature_not_assigned", {
                        state: hasCreateUserService.unavailableService,
                      });
                    }
                  },
                  isDisabled: !hasCreateUserService.status,
                  enabledTextColor: "var(--primary-bg)",
                  disabledTextColor: null,
                  enabledBgColor: "var(--text-primary)",
                  disabledBgColor: null,
                  isLoading: false,
                  outLineColor: null,
                  hoverOption: "black",
                  buttonRef: null,
                  fullWidthRequired: null,
                  inActiveVariantNeeded: null,
                  isLoaderNeeded: null,
                  icon: ICONS?.ADD_BUTTON_WHITE,
                  imgColor: "var(--primary-bg)",
                  iconToBeAlign: "right",
                }
          }
          assignTagProps={
            multiSelect
              ? undefined
              : {
                  btnType: "button",
                  handleFunction: () => {
                    if (type === "popup") {
                      actionRestricted();
                      return;
                    }
                    setMultiSelect(true);
                  },
                  isDisabled: type === "popup",
                  enabledTextColor: "var(--text-primary)",
                  disabledTextColor: null,
                  enabledBgColor: "var(--primary-bg)",
                  disabledBgColor: null,
                  isLoading: false,
                  outLineColor: null,
                  hoverOption: "white",
                  buttonRef: null,
                  fullWidthRequired: null,
                  inActiveVariantNeeded: null,
                  isLoaderNeeded: null,
                  iconToBeAlign: "right",
                }
          }
          ispagination={hasUsers}
          isSelectionView={multiSelect}
          BottomSubText={
            multiSelect
              ? "Select users to apply tags. These tags will be used to generate statistics for the associated users."
              : ""
          }
          BottomSubTextVaraint="primary"
          selectionText={`Users selected - ${usersArray?.length || GlobalConfiguration.lengthCheckZero}`}
          selectionBtnProps={
            multiSelect
              ? {
                  btnText: `Select up to ${Number(selectedValue)}`,
                  enabledBgColor:
                    usersArray?.length === Number(selectedValue)
                      ? "var(--positive-bg)"
                      : "var(--primary-nav-act)",
                  isDisabled: loader || !hasUsers,
                  handleFunction: (e) => {
                    e.stopPropagation();
                    if (hasUsers) {
                      handleSelectAllUsers();
                    }
                  },
                  iconToBeAlign: "left",
                  enabledTextColor: "var(--text-primary)",
                  icon:
                    !loader && usersArray?.length === Number(selectedValue)
                      ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                      : ICONS?.SELECT_ALL_WITH_WHITE_OUTLINE_CIRCLE,
                  fullWidthRequired: false,
                  hoverOption:
                    usersArray?.length === Number(selectedValue)
                      ? "black"
                      : "white",
                }
              : undefined
          }
          topNavCtaBtn2Props={
            multiSelect
              ? {
                  btnText: "Assign tags",
                  btnType: "button",
                  enabledBgColor: usersArray?.length
                    ? "var(--text-primary)"
                    : "var(--text-disabled)",
                  handleFunction: () => {
                    if (!usersArray.length) return;
                    setIsTagsPopupOpen(true);
                  },
                  enabledTextColor: usersArray?.length
                    ? "var(--primary-bg)"
                    : "var(--text-primary)",
                  hoverOption: "black",
                  inActiveVariantNeeded: true,
                  isDisabled: !usersArray?.length,
                }
              : null
          }
          filteredSearchProps={{
            inputData,
            setInputData,
            showInnerSearchBar: showInnerSearchBar,
            setShowInnerSearchBar: setShowInnerSearchBar,
            active,
            setActive,
            onSearchInput: setTypedText,
            searchText: typedText,
            filterPlaceholder:
              "first name/ last name/ user ID/ full name/ contact number / email ID",
            searchPlaceholder:
              "Search by first name/ last name/ user ID/ full name/ contact number / email ID",
            isShowSortBy: true,
            isShowFilter: true,
            filterItems: [
              {
                name: "Search",
                isMulti: false,
                value: searchUserText,
                setValue: (val) => {
                  setCurrentPage(GlobalConfiguration.lengthCheckOne);
                  handleSubmit("search", val);
                  setSearchUserText(val);
                },
                isDropdown: false,
                isDisabled: false,
              },
              {
                name: "Tags",
                short_name: "Tag",
                isMulti: true,
                value: ownerTagState,
                setValue: (val) => {
                  setCurrentPage(GlobalConfiguration.lengthCheckOne);
                  handleSubmit("tags", val);
                  setOwnerTagState(val);
                },
                isDropdown: true,
                isDisabled: false,
              },
            ],
            filters: [
              {
                name: "Grade",
                filterType: "dropdown",
                variant: "single",
                size: "small",
                value: selectedGrade,
                dropdownPlaceHolder: "Select Grade",
                isDisabled: true,
                options: mainData?.available_grades?.map((x) => x.trim()) ?? [],
                statusPop: true,
                handleChange: (val) => {
                  handleSubmit("grade", val);
                  setSelectedGrade(val);
                  setCurrentPage(GlobalConfiguration.lengthCheckOne);
                },
              },
              {
                name: "Status",
                filterType: "dropdown",
                variant: "single",
                dropdownPlaceHolder: "Select status",
                size: "small",
                value: selectedStatus,
                options: ["Active", "Inactive"],
                handleChange: (val) => {
                  handleSubmit("status", val);
                  setSelectedStatus(val);
                  setCurrentPage(GlobalConfiguration.lengthCheckOne);
                },
              },
            ],
            sortByFilter: [
              {
                name: "Alphabetical : A to Z",
                default: true,
              },
              {
                name: "Alphabetical : Z to A",
              },
              {
                name: "Order : Latest",
              },
              {
                name: "Order : Oldest",
              },
            ],
            isSortDefaultDisabled:
              sortValue === "" || sortValue === "ascending",
            isFilterClearAllDisabled:
              selectedGrade === "" && selectedStatus === "",
            sortValue: sortValue,
            sortHandleChange: (val) => {
              handleSubmit("sort", val);
              setSortValue(val);
              setCurrentPage(GlobalConfiguration.lengthCheckOne);
            },
          }}
        />
      </div>

      <div
        className={`flex-1 min-h-0 overflow-hidden relative ${showInnerSearchBar ? "pointer-events-none" : ""}`}
      >
        {showInnerSearchBar && (
          <div className="absolute bg-PopUp-BackDrop opacity-dark-opacity pointer-events-none w-full h-full z-z-index-header"></div>
        )}
        {showLoader ? (
          <div className="loader-container grid place-items-center h-full w-full">
            <Loader />
          </div>
        ) : hasUsers ? (
          <div
            ref={filterRef}
            onScroll={handleGridScroll}
            className={`scroll flex flex-col items-center h-full overflow-y-auto scroll-py-top_md w-full ${showInnerSearchBar ? "pointer-events-none opacity-dark-opacity" : ""} ${multiSelect ? "pt-padding-base" : ""}`}
          >
            <div
              className={`standard-card-alignment gap-x-gap-sm gap-y-gap-md ${isScrolling ? "pointer-events-none" : ""}`}
            >
              {usersDetails?.map((userDtls) => {
                const isSelf =
                  userDtls.user_id === sessionStorage.getItem("user_id");
                return (
                  <CardContainer
                    filterRef={filterRef}
                    hoverHeight={GlobalConfiguration?.userHoverHeight}
                    key={userDtls?.id}
                    context={userDtls}
                    isSelected={
                      multiSelect && selectedUserIds.includes(userDtls?.id)
                    }
                    isDisabled={(() => {
                      // Order of these matters
                      // So do not change
                      // Unless ofc, you need to.
                      if (type === "popup") return false;
                      if (multiSelect) return false;
                      if (ensureAll(["VSpecificEmp", "Admin"]).status)
                        return false;
                      if (ensureAll(["VSpecificEmp"]).status && isSelf)
                        return false;
                      return true;
                    })()}
                    onClickHandler={(e, context) => {
                      if (multiSelect) {
                        e.stopPropagation();
                        handleSingleSelect(
                          usersArray,
                          setUsersArray,
                          selectedValue,
                          context,
                        );
                      } else {
                        handleUserDetails(context);
                      }
                    }}
                  >
                    <card-body>
                      <TextWithIcon
                        type={"text"}
                        fontWeight={"normal"}
                        text={userDtls?.user_id}
                        subText={"User ID"}
                        textColor={"var(--text-primary)"}
                        iconComponentArray={
                          multiSelect
                            ? [
                                {
                                  icon: selectedUserIds.includes(userDtls?.id)
                                    ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                                    : ICONS?.NOT_SELECTED_WITH_GREY_CIRCLE,
                                  isDisabled: false,
                                },
                              ]
                            : []
                        }
                      />
                      <TextWithIcon
                        type={"text"}
                        fontWeight={"normal"}
                        text={[userDtls?.first_name, userDtls?.last_name]
                          .filter(Boolean)
                          .join(" ")}
                        subText="User name"
                        textColor={"var(--text-primary)"}
                      />
                    </card-body>
                    <card-hover>
                      <TextWithIcon
                        type={"text"}
                        fontWeight={"normal"}
                        text={
                          userDtls?.account_tags?.length
                            ? userDtls?.account_tags.join(", ")
                            : "No tags assigned"
                        }
                        textColor={"var(--text-primary)"}
                        iconComponentArray={[
                          {
                            icon: ICONS?.ASSIGN_TAG_WITHOUT_CIRCLE,
                            isDisabled: false,
                          },
                        ]}
                      />
                    </card-hover>
                  </CardContainer>
                );
              })}
            </div>
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center m-auto w-full h-full">
            <img
              src={ICONS?.NO_DATA_FOUND}
              alt="No accounts found"
              className="opacity-base-opacity w-graphic-width-md h-graphic-rectangle-height-md mb-margin-sm"
            />
            <p className="text-font-sm text-text-primary items-center font-normal mb-margin-sm">
              No data found.
            </p>
            {(ownerTagState?.length > GlobalConfiguration.lengthCheckZero ||
              searchUserText?.length > GlobalConfiguration.lengthCheckZero) && (
              <PrimaryButton
                isDisabled={showInnerSearchBar}
                enabledBgColor="var(--primary-act)"
                btnText="Clear parameters"
                enabledTextColor="var(--text-primary)"
                handleFunction={handleClearParams}
                buttonRef={null}
                hoverOption="white"
              />
            )}
          </div>
        )}
      </div>

      {hasUsers && !showLoader && (
        <div
          className={`flex-shrink-0 ${flow === "create" ? "h-pagination-height" : "h-topnav-bottom-height Qsmd:h-pagination-height"}`}
        ></div>
      )}
    </div>
  );
};

export default UsersSettings;
